import script from "./ResultadosConsolidadosView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultadosConsolidadosView.vue?vue&type=script&setup=true&lang=ts"

import "./ResultadosConsolidadosView.vue?vue&type=style&index=0&id=20056d1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20056d1c"]])

export default __exports__